import SelectFacet from 'govbr.frontend.policy/components/Blocks/Search/components/SelectFacet';

export default SelectFacet;
